export const projectTitleToAlias = (title: string) => {
  return title
    .toLowerCase()
    .replace(/[^\w\s]/gi, "")
    .replace(/ /g, "_");
};
